export enum EFrindsListState {
  FLS_Invalid,
  FLS_Querying,
  FLS_Valid,
}
